<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button aria-controls="collapse0" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse0" data-bs-toggle="collapse" type="button">
                Vrijgesteld loon
            </button>
        </h2>
        <div aria-labelledby="heading0" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse0">
            <div class="accordion-body">
                Kies 'Vrijgesteld loon' als de persoon inkomsten had als (oud-)werknemer bij een internationale
                organisatie. De persoon werkte bijvoorbeeld bij de Europese Unie, de Verenigde Naties of de NAVO. In
                Nederland hoef je dan geen belasting te betalen over deze inkomsten, maar je moet deze wel aangeven.

                <div class="space10"></div>
                Is de persoon Nederlands ambtenaar en in dienst van Justitie op Curaçao? Kies dan ook 'Vrijgesteld
                loon'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Werken voor een internationale volkenrechtelijke organisatie
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Heeft iemand inkomsten als (oud-)werknemer bij bepaalde internationale volkenrechtelijke organisaties?
                Dan zijn de inkomsten misschien vrijgesteld van belasting in Nederland. De vrijgestelde inkomsten tellen
                niet mee bij het berekenen van de inkomstenbelasting. Wel tellen ze mee bij het bepalen van
                bijvoorbeeld:

                <li class="list">de drempel voor de aftrek van specifieke zorgkosten en giften</li>
                <li class="list">de heffingskortingen</li>
                <li class="list">het toetsingsinkomen voor inkomensafhankelijke regelingen, zoals zorgtoeslag,
                    huurtoeslag,
                    kinderopvangtoeslag en kindgebonden budget
                </li>

                <div class="space10"></div>
                Je moet deze inkomsten dus wel aangeven.
                <div class="space10"></div>

                <b>Internationale volkenrechtelijke organisaties</b><br/>
                De inkomsten zijn misschien vrijgesteld als de persoon bijvoorbeeld werkte bij:
                <li class="list">de Europese Unie</li>
                <li class="list">de Verenigde Naties</li>
                <li class="list">de NAVO</li>
                <li class="list">het Internationaal Gerechtshof</li>
                <li class="list">het Europese Octrooibureau</li>
                <li class="list">de ESA/ESTEC</li>
                <div class="space10"></div>

                <b>Als VN-militair uitgezonden</b><br/>
                Is de persoon als VN-militair uitgezonden en maakt hij deel uit van een stabilisatiemacht onder leiding
                van de NAVO? Dan moet hij over zijn inkomsten belasting betalen. De onkostenvergoeding van de VN is
                mogelijk niet belast. Meer informatie hierover kun je krijgen bij de werkgever.
                <div class="space10"></div>

                <b>Pensioen van de Europese Unie</b><br/>
                Ontvangt iemand pensioen van de Europese Unie, dan hoef je daarover in Nederland geen belasting te
                betalen.
                <div class="space10"></div>

                <b>Pensioenen van andere internationale organisaties</b><br/>
                Over pensioen van andere internationale organisaties moet je in Nederland belasting betalen.


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button aria-controls="collapse2" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2" data-bs-toggle="collapse" type="button">
                Premieloon (premie volksverzekeringen) en land voor de Zorgverzekeringswet (Zvw)
            </button>
        </h2>
        <div aria-labelledby="heading2" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse2">
            <div class="accordion-body">
                Als je in Nederland verplicht verzekerd bent voor de sociale zekerheid, dan ben je ook premie
                volksverzekeringen verschuldigd. In sommige situaties ben je in Nederland niet verzekerd voor de
                volksverzekeringen, of slechts een deel van het jaar.
                <div class="space10"></div>

                Was je in een jaar in Nederland verplicht verzekerd voor de volksverzekeringen? En moest je over
                diezelfde periode in een ander land over je inkomen premie voor de sociale zekerheid betalen? Of was je
                dit verschuldigd aan een volkenrechtelijke instantie, bijvoorbeeld de UNESCO of het Internationaal
                Strafhof? Dan kun je in de volgende situaties een correctie van uw premie-inkomen krijgen:<br/>

                <li>Je krijgt een uitkering bij ouderdom en overlijden volgens de socialezekerheidswetgeving van een
                    ander land. Voor die uitkering betaal je in dat land premie.
                </li>

                <li>Je valt volgens een internationale regeling naast de Nederlandse socialezekerheidswetgeving ook
                    onder de wetgeving van het land waarin je werkt. Je werkt bijvoorbeeld in Nederland in loondienst en
                    in België als zelfstandige.
                </li>

                <li>Je hebt inkomsten uit loondienst in Nederland bij een internationale volkenrechtelijke organisatie
                    of bij de overheid van een ander land dan Nederland en je hebt inkomsten uit andere werkzaamheden.
                    De correctie op je premie-inkomen krijg je alleen voor de inkomsten uit loondienst bij de
                    internationale volkenrechtelijke organisatie of de overheid van het andere land. Dus niet voor de
                    inkomsten uit ander werk.
                </li>
                <div class="space10"></div>

                Je premie-inkomen is nooit meer dan het totale inkomen min het inkomen waarover je in een ander land
                premie betaalt en kent jaarlijks een maximum.
                <div class="space10"></div>
                Meer informatie over internationale detachering vind je op de site van de <a
                    href="https://www.svb.nl/nl/id" target="_blank">Sociale Verzekeringsbank</a>.

            </div>
        </div>
    </div>

</div>

